import React from "react"
import styles from "./styles.scss"
import cx from "classnames"
import HoverLink from "components/HoverLink"
import HashLink from "components/HashLink"

const burgerClasses = [{ name: "top" }, { name: "mid" }, { name: "bot" }]

class BurgerMenu extends React.Component {
  state = { open: false }

  toggleMenu = () => this.setState({ open: !this.state.open })

  closeMenu = () => this.setState({ open: false })

  render() {
    const { links } = this.props

    return (
      <div id="menu" className={styles.menu}>
        <div
          className={cx(styles.burger, {
            [styles.open]: this.state.open,
            [styles.whiteVariant]: this.props.variant,
          })}
          onClick={this.toggleMenu}
        >
          {burgerClasses.map(burgerClass => (
            <div key={burgerClass.name} className={styles[burgerClass.name]} />
          ))}
        </div>

        <div
          className={cx(styles.blackout, styles.burgerBlackout, {
            [styles.open]: this.state.open,
          })}
          onClick={this.closeMenu}
        >
          <div className={styles.menuOpen}>
            <ul className={styles.menuList}>
              {links.map(link => (
                <li key={link.name} className={styles.menuListItem}>
                  <HoverLink>
                    <HashLink to={link.path} text={link.name} />
                  </HoverLink>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    )
  }
}

export default BurgerMenu



// WEBPACK FOOTER //
// ./src/components/MenuBar/BurgerMenu/index.jsx